import { css } from 'styled-components';

export const omniTheme = css`
    --color-primary: #5C8E81;

    --color-state-primary:rgba(92, 142, 129, 0.07);
    --color-state-secondary: rgba(92, 142, 129, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: #DE5E3A;

    /* Home Page */
    --home-hero-background: #5C8E81;
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #FFF8EC;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: var(--color-primary);
`;
